// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".datalayer-container a{cursor:pointer;color:#337ab7}.datalayer-container .table-height{height:calc(100vh - 170px)!important;overflow:auto;position:relative}.datalayer-container .back,.rule-close{position:absolute;cursor:pointer;z-index:1}.rule-close{right:-25px;font-size:18px}", ""]);
// Exports
module.exports = exports;
